import {
  validateSalutation,
  validateFirstName,
  validateLastName,
  validatePhone,
  validateCheckBox, validateEmailStartingFromUpperCase,
  validateStateCode,
} from './Validators';

export default function validateProgramBuilderDetailForm(obj) {
  const salutationResponse = validateSalutation(obj.salutation.value);
  const firstNameResponse = validateFirstName(obj.firstName);
  const lastNameResponse = validateLastName(obj.lastName);
  const emailResponse = validateEmailStartingFromUpperCase(obj.email);
  const stateCodeResponse = validateStateCode(obj.stateCode, obj.country);
  let phoneNumberResponse;
  if (obj.phoneNumber != null) {
    phoneNumberResponse = validatePhone(
      obj.phoneNumber,
      obj.isPhoneNumberValid
    );
  }
  const agreementCheckboxResponse = validateCheckBox(obj.agreementCheckbox);
  const res = {
    errors: {},
  };
  if (salutationResponse.isError) {
    res.isError = salutationResponse.isError;
    res.errors.salutation = salutationResponse.message;
  }
  if (firstNameResponse.isError) {
    res.isError = firstNameResponse.isError;
    res.errors.firstName = firstNameResponse.message;
  }
  if (lastNameResponse.isError) {
    res.isError = lastNameResponse.isError;
    res.errors.lastName = lastNameResponse.message;
  }
  if (emailResponse.isError) {
    res.isError = emailResponse.isError;
    res.errors.email = emailResponse.message;
  }
  if (phoneNumberResponse && phoneNumberResponse.isError) {
    res.isError = phoneNumberResponse.isError;
    res.errors.phoneNumber = phoneNumberResponse.message;
  }
  if (agreementCheckboxResponse.isError) {
    res.isError = agreementCheckboxResponse.isError;
    res.errors.agreementCheckbox = agreementCheckboxResponse.message;
  }
  if (stateCodeResponse.isError) {
    res.isError = stateCodeResponse.isError;
    res.errors.stateCode = stateCodeResponse.message;
  }  
  return res;
}
